import { createEntityAdapter } from "@reduxjs/toolkit";
import { createAppSlice } from "../../../lib/store/createAppSlice.js";
import { PerxisService } from "../../../services/perxis/index.js";
import { name } from "../config/name.js";
const adapter = createEntityAdapter();
const slice = createAppSlice({
  name,
  initialState: adapter.getInitialState(),
  reducers: (create) => ({
    addReference: create.reducer((state, action) => {
      adapter.addOne(state, action.payload);
    }),
    addReferences: create.reducer((state, action) => {
      adapter.addMany(state, action.payload);
    }),
    removeReference: create.reducer((state, action) => {
      adapter.removeOne(state, action.payload);
    }),
    removeReferences: create.reducer((state, action) => {
      adapter.removeMany(state, action.payload);
    }),
    fetchReferences: create.asyncThunk(
      async (parameters) => {
        const { referencesClient } = PerxisService.getInstance();
        const response = await referencesClient.get({
          ...parameters,
          references: parameters.references.map(({ collection_id: collectionId, ...rest }) => ({
            ...rest,
            collectionId
          }))
        });
        return [...response.items, ...response.notfound];
      },
      {
        fulfilled: (state, action) => {
          adapter.setAll(state, action.payload);
        }
      }
    )
  })
});
const { reducer, actions, reducerPath } = slice;
const selectors = adapter.getSelectors();
export {
  actions,
  adapter,
  reducer,
  reducerPath,
  selectors,
  slice
};
